import { useRef } from "react";
import { CheckCircle2, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal } from "./Reveal";

const finished = [
  {
    img: "/finalizados/bmw-x5.jpg",
    service: "Remoção de painel",
    vehicle: "BMW X5",
  },
  {
    img: "/finalizados/tiguan.jpg",
    service: "Instalação de farol de milha",
    vehicle: "VW Polo",
  },
  {
    img: "/finalizados/atego.jpg",
    service: "Alternador 24V",
    vehicle: "Mercedes-Benz Atego",
  },
  {
    img: "/finalizados/fusion.jpg",
    service: "LED 14.000 lúmens · 1 ano de garantia",
    vehicle: "Ford Fusion",
  },
  {
    img: "/finalizados/gol.jpg",
    service: "Troca de bomba de combustível",
    vehicle: "Volkswagen Gol",
  },
  {
    img: "/finalizados/polo-alternador.jpg",
    service: "Alternador substituído · atendimento noturno",
    vehicle: "VW Polo",
  },
  {
    img: "/finalizados/luz-bateria.jpg",
    service: "Luz de bateria acesa — diagnóstico de carga",
    vehicle: "Sistema de carga",
  },
  {
    img: "/finalizados/arranque-revisao.jpg",
    service: "Revisão de arranque · kit de escovas novo",
    vehicle: "Motor de partida",
  },
  {
    img: "/finalizados/porsche-arranque.jpg",
    service: "Remoção de motor de arranque",
    vehicle: "Ford Focus",
  },
  {
    img: "/finalizados/montagem-painel.jpg",
    service: "Montagem de painel completo",
    vehicle: "Chicote do painel",
  },
  {
    img: "/finalizados/painel-van.jpg",
    service: "Elétrica de cabine e painel",
    vehicle: "Van / utilitário",
  },
  {
    img: "/finalizados/multimetro.jpg",
    service: "Diagnóstico com multímetro",
    vehicle: "Caixa de fusíveis",
  },
  {
    img: "/finalizados/chicote.jpg",
    service: "Reparo de chicote elétrico",
    vehicle: "Fiação refeita no local",
  },
  {
    img: "/finalizados/solda-led.jpg",
    service: "Solda de LEDs em placa",
    vehicle: "Reparo de painel",
  },
  {
    img: "/finalizados/alternador-pecas.jpg",
    service: "Revisão de alternador desmontado",
    vehicle: "Peças novas a bordo",
  },
  {
    img: "/finalizados/alternador-aberto.jpg",
    service: "Alternador aberto — revisão completa",
    vehicle: "Rotor e carcaça",
  },
  {
    img: "/finalizados/teste-bateria.jpg",
    service: "Teste de carga aprovado — 14.4V",
    vehicle: "Bateria e alternador",
  },
  {
    img: "/finalizados/conectores.jpg",
    service: "Chicote do console central",
    vehicle: "Conectores e fiação",
  },
  {
    img: "/finalizados/modulo.jpg",
    service: "Reparo em módulo eletrônico",
    vehicle: "Placa de circuito",
  },
  {
    img: "/finalizados/alternador-caminhao.jpg",
    service: "Alternador novo instalado",
    vehicle: "Caminhão — no local",
  },
  {
    img: "/finalizados/axor-rodovia.jpg",
    service: "Socorro em rodovia à noite",
    vehicle: "Mercedes-Benz Axor",
  },
  {
    img: "/finalizados/rotor.jpg",
    service: "Recuperação de rotor de alternador",
    vehicle: "Coletor novo no lugar",
  },
  {
    img: "/finalizados/reles-fusiveis.jpg",
    service: "Troca de relés e fusíveis",
    vehicle: "Elétrica em geral",
  },
  {
    img: "/finalizados/central-fusiveis.jpg",
    service: "Central de fusíveis e relés",
    vehicle: "Chicote principal",
  },
  {
    img: "/finalizados/arranque-aberto.jpg",
    service: "Arranque desmontado — revisão",
    vehicle: "Induzido e escovas",
  },
];

export default function FinishedJobs() {
  const trackRef = useRef(null);

  const scroll = (dir) => {
    trackRef.current?.scrollBy({ left: dir * 360, behavior: "smooth" });
  };

  return (
    <section id="finalizados" data-testid="finished-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="flex items-end justify-between gap-6">
          <div>
            <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#e8112d] font-semibold mb-4">
              Trabalhos entregues
            </p>
            <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
              Serviços finalizados no local
            </h2>
          </div>
          <div className="hidden sm:flex gap-3">
            <button
              data-testid="finished-carousel-prev"
              onClick={() => scroll(-1)}
              aria-label="Anterior"
              className="w-12 h-12 rounded-full border border-white/15 hover:border-[#e8112d]/60 flex items-center justify-center text-slate-300 hover:text-[#e8112d] transition-all duration-300 hover:bg-white/5"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              data-testid="finished-carousel-next"
              onClick={() => scroll(1)}
              aria-label="Próximo"
              className="w-12 h-12 rounded-full border border-white/15 hover:border-[#e8112d]/60 flex items-center justify-center text-slate-300 hover:text-[#e8112d] transition-all duration-300 hover:bg-white/5"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 max-w-7xl mx-auto pl-5 sm:pl-8">
        <div
          ref={trackRef}
          data-testid="finished-carousel"
          className="no-scrollbar flex gap-5 overflow-x-auto snap-x snap-mandatory pb-4 pr-5 sm:pr-8"
        >
          {finished.map((f, i) => (
            <figure
              key={i}
              data-testid={`finished-item-${i + 1}`}
              className="group relative shrink-0 w-[280px] sm:w-[340px] snap-start overflow-hidden rounded-2xl border border-white/5 hover:border-[#e8112d]/40 transition-all duration-500"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={f.img}
                  alt={`${f.service} — ${f.vehicle}`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
              <span className="absolute top-4 right-4 inline-flex items-center gap-1.5 bg-black/60 border border-[#25D366]/50 text-[#25D366] font-tech text-[10px] uppercase tracking-[0.16em] px-3 py-1.5 rounded-full backdrop-blur-sm">
                <CheckCircle2 className="w-3.5 h-3.5" />
                Entregue
              </span>
              <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-sm font-semibold text-white leading-snug">{f.service}</p>
                <p className="font-tech text-[11px] uppercase tracking-[0.16em] text-slate-400 mt-2">
                  {f.vehicle}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="font-tech text-[11px] uppercase tracking-[0.2em] text-slate-600 mt-2 sm:hidden">
          Arraste para o lado
        </p>
      </div>
    </section>
  );
}
